module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5r6n8r7n-5962230d618a60e8927e61b312e40ebe.svg";